import { render, staticRenderFns } from "./LettersDash.vue?vue&type=template&id=1ba83b9f&scoped=true&"
import script from "./LettersDash.vue?vue&type=script&lang=js&"
export * from "./LettersDash.vue?vue&type=script&lang=js&"
import style0 from "./LettersDash.vue?vue&type=style&index=0&id=1ba83b9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba83b9f",
  null
  
)

export default component.exports